<template lang="html">
<div class="conversation">
    <div class="Vlt-gradient--pink-to-peach" style="border-radius: 8px; height: 430px;">
        <div v-if="convos.length>0" class="Vlt-card Vlt-card--scrollable" style="height: 420px;">
            <div class="Vlt-card__header">
                <!-- <h4>Conversation Events</h4> -->
                <div class="Vlt-native-dropdown">
                    <select name="convSelect" id="convSelect" v-model="conType">
                        <option value="all">All</option>
                        <option v-for="cType in cTypes" :value="cType">{{ cType }}</option>
                    </select>
                </div>
                <vlt-button :label="depth?'Contract View':'Expand View'" secondary @click="expand()" /><br />
            </div>
            <div class="Vlt-card__content">
                <div class="Vlt-table Vlt-table--short">
                    <table>
                        <tbody>
                            <div>
                                <tr v-for="convo in convos">
                                    <td v-if="(conType=='all' || convo.type==conType) && (oldkey==newkey)">
                                        <json-view :data="convo" :maxDepth="depth" :rootKey="convo.type+' at '+convo.timestamp" />
                                    </td>
                                </tr>
                            </div>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="js">
import {
    JSONView
} from "vue-json-component";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltDropdown,
    VltCheckbox,
} from "@vonagevolta/vue";

export default {
    name: 'conversations',
    components: {
        "json-view": JSONView,
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-dropdown": VltDropdown,
        "vlt-input": VltInput,
        "vlt-checkbox": VltCheckbox,
    },
    props: {
        convos: {
            type: Array,
            required: false
        },
    },
    data() {
        return {
            conType: 'all',
            cTypes: [],
            depth: 0,
            oldkey: 0,
            newkey: 0,
        }
    },
    watch: {
    },
    methods: {
        expand() {
            this.newkey++;
            this.depth = this.depth ? 0 : 6;
            console.log("Expanded: " + this.depth);
                this.$nextTick(() => {
                    // ...other synchronous work here that causes other DOM changes
                    this.oldkey = this.newkey
                })
        }

    },
    created() {
        if (this.convos) {
            this.cTypes = [...new Set(this.convos.map(item => item.type))];
            this.conType = 'all';
        }
    },
    mounted() {},

}
</script>

<style scoped lang="scss">
</style> 
